import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import wx from 'jweixin-npm';

palyvideo()
function palyvideo(){
  if($('video').length>0){
    let videolist = $('video')
    console.log(videolist)
    for(let i=0; i<videolist.length; i++){
      videolist[i].play()
    }
  }
}

document.addEventListener("WeixinJSBridgeReady", function () {
  palyvideo()
}, false);

$(document).ready(function(){
  let paddingLeft = $('.section1').css("padding-left")
  let navLeft = $('.section1 .pro-series a.active').offset().left - parseInt(paddingLeft.replace('px', ''))
  $('.section1 .scroll').scrollLeft(navLeft)
})